import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// The generated GraphqlApiService falls back to a hardcoded endpoint when
// window.GRAPHQL_API_ENDPOINT is unset. We must NOT edit the SDK, so point it at the
// configured endpoint here (before bootstrap, ahead of any SDK use).
(window as unknown as { GRAPHQL_API_ENDPOINT?: string }).GRAPHQL_API_ENDPOINT =
  environment.graphqlEndpoint;

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
